import { useDateFormat } from '@vueuse/core'

export const useDate = () => {
  const dateFormatter = (options: object = {}) => new Intl.DateTimeFormat('id-ID', options)

  const addDay = (date: Date) => {
    return addDays(date, 1)
  }

  const addDays = (date: Date, days: number) => {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate
  }

  const subDay = (date: Date) => {
    return subDays(date, 1)
  }

  const subDays = (date: Date, days: number) => {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() - days)
    return newDate
  }

  /**
   * @todo refactor to useDateFormat https://vueuse.org/shared/useDateFormat
   */
  const formatHumanDate = (date: string | null = null): string => {
    if (!date) {
      return '-'
    }

    return dateFormatter({
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }).format(new Date(date))
  }

  /**
   * @todo refactor to useDateFormat https://vueuse.org/shared/useDateFormat
   */
  const formatHumanDateTime = (date: string | null = null): string => {
    if (!date) {
      return '-'
    }

    return dateFormatter({
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date(date))
  }

  const formatRelativeTime = (date: string | null = null) => {
    if (!date) {
      return '-'
    }

    const now = new Date()
    const theDate = new Date(date)
    const interval = now.getTime() - theDate.getTime()

    const seconds = Math.floor(interval / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    // Display normal date if beyond 7 days
    if (days > 7) {
      return formatHumanDateTime(date)
    }

    const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' })

    if (seconds < 60) {
      return rtf.format(-seconds, 'second')
    }

    if (minutes < 60) {
      return rtf.format(-minutes, 'minute')
    }

    if (hours < 24) {
      return rtf.format(-hours, 'hour')
    }

    if (1 === days) {
      return 'Yesterday'
    }

    return rtf.format(-days, 'day')
  }

  const formatDate = (date: Date | null = null, format = 'DD-MM-YYYY') => {
    if (!date) {
      return ''
    }

    const formatted = useDateFormat(date, format, { locales: 'id-ID' })
    return formatted.value
  }

  return {
    addDay,
    addDays,
    subDay,
    subDays,
    formatDate,
    formatHumanDate,
    formatHumanDateTime,
    formatRelativeTime
  }
}
